// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1DwM5","boxTitle":"Qualiphy_boxTitle__1RKl2","box":"Qualiphy_box__3Nf1Q","toggleWrap":"Qualiphy_toggleWrap__nnr5R"};